<template>
    <div class="main" title="Toggle Lat/Lon Pointer">
       <toggle-button :sync="true" class="toggle" :labels="true" v-model="checkbox" :width="45" :height="22" :color="{checked: '#0496e9', unchecked: 'lightgray'}" />
    </div>
</template>

<script>
export default {
  name: 'MMP_LatLongToggle',
  data() {
    return {
        checkbox: true
    }
  },
  methods: {
    toggleTrue() {
      this.checkbox = true
    }
  },
  watch: {
    checkbox: function () {
        this.$emit('toggleChange', this.checkbox)
    }
  }
}
</script>

<style scoped>
.main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 60px;
    width: 50px;
    text-align: center;
    position: fixed;
}

.toggle {
    margin-bottom: 10px;
}
</style>